import { OperatorOption } from '@/components/publicSearch/constants';
import useFilterStore from '@/publicSearch/store/useFilterStore';
import { useSearchType } from './useSearchType';
import usePublicSearchContext from '@/publicSearch/store/usePublicSearchContext';
import { SnackbarKey, closeSnackbar, enqueueSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import { SNACKBAR_VARIANT } from '@/constants/notifications';

export function useSearchPrecheck(enabled: boolean) {
  const searchType = useSearchType();
  const { filters } = useFilterStore(searchType);
  const orgId = usePublicSearchContext((context) => context.society.orgId);
  const [errorDisplayKey, setErrorDisplayKey] = useState<SnackbarKey>();

  const checkError = useCallback(() => {
    if (!orgId) return 'Please select society before search';

    let unsetFilter = filters.find(
      (f) =>
        !f.field ||
        !f.operator ||
        (f.operator !== OperatorOption.isNotEmpty.value &&
          (!f.value || f.value.length === 0)),
    );
    if (unsetFilter) {
      return unsetFilter.field
        ? `Please finish setting advance filter for "${unsetFilter.field}" before search`
        : `Please finish setting all advance filter before search`;
    }

    return null;
  }, [filters, orgId]);

  const hideError = useCallback(
    () => closeSnackbar && closeSnackbar(errorDisplayKey),
    [errorDisplayKey],
  );

  const showError = useCallback(() => {
    if (!enabled) return setErrorDisplayKey(undefined);

    let errorMsg = checkError();
    if (!errorMsg) return setErrorDisplayKey(undefined);

    let key = enqueueSnackbar(errorMsg, {
      variant: SNACKBAR_VARIANT.ERROR,
      persist: true,
      anchorOrigin: {
        horizontal: 'center',
        vertical: 'bottom',
      },
      onClose: () => setErrorDisplayKey(undefined),
    });
    setErrorDisplayKey(key);
    return key;
  }, [enabled, checkError]);

  return {
    errorShown: !!errorDisplayKey,
    hideError,
    showError,
  };
}
